/**
 * Constructs an application-wide event bus so that components can alert each other to events using broadcasts, even if the component emitting the event is not actually
 * a Vue component itself.  This is used to allow things like the page controller service to control the data and business logic on behalf of the application and then
 * inform views that depend upon it that the data has changed.
 */
import Vue from 'vue';
export default new Vue();

